import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
  TextField,
  Divider,
  Select,
  Input,
  InputLabel,
  MenuItem,
  ListItemText,
  RadioGroup,
  Radio,
} from "@mui/material";
import { makeStyles, useTheme } from "@mui/styles";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";

const useStyles = makeStyles((theme) => ({
  root: {},
  formControl: {
    width: "100%",
  },
  errorText: {
    fontSize: "100%",
    color: theme.palette.error.dark,
    fontWeight: "bold",
  },
}));
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const CombinedJob = ({
  open,
  handleClose,
  formOptions,
  formFields,
  source,
  submitButton,
  setRefresh,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  //CHECKBOX FOR ACTIVATION OF TYPE
  const getCheckBox = () => {
    let state = {};
    Object.keys(formFields).forEach((key) => {
      if (key !== "main" && key !== "common") state[[key]] = false;
    });
    return state;
  };
  const [checkboxState, setCheckboxState] = useState(getCheckBox());

  const getCommon = () => {
    let common = [...formFields["common"]];
    if (formFields["main"]) common.push(...formFields["main"]);

    return common;
  };
  const commonFields = getCommon();

  //TYPE DATA
  const setupStateFromProps = () => {
    let state = {};
    const sections = [];

    Object.keys(formFields).forEach((key) => {
      if (key !== "main" && key !== "common") sections.push(key);
    });

    //FOR EXTERNAL FIELDS
    commonFields.map((value) => {
      if (value.type === "Options") state[[value.name]] = [];
      if (value.type === "Radio") state[[value.name]] = "Custom";

      if (value.type === "SubTypes") {
        state[[value.name]] = {};
        value.types.forEach((subType, index) => {
          state[[value.name]][[subType.name]] = 0;
        });
      }
      return null;
    });

    // FOR FIELDS IN EACH SECTION
    sections.map((value) => {
      state[[value]] = {};

      formFields[[value]].map((field) => {
        if (field.type === "Options") state[[value]][[field.name]] = [];
        if (value.type === "Radio") state[[value]][[field.name]] = "Custom";

        return null;
      });
      return null;
    });

    return state;
  };

  const [formData, setFormData] = useState(setupStateFromProps());

  //FORM MANAGEMENT
  const handleChange = (event) => {
    setCheckboxState({
      ...checkboxState,
      [event.target.name]: event.target.checked,
    });
  };

  const handleFormChange = (event, type, fieldType) => {
    let { value, name } = event.target;

    if (fieldType === "Date") value = value + ":00Z";
    if (fieldType === "number") value = parseInt(value);

    if (type)
      setFormData((prevState) => ({
        ...prevState,
        [type]: {
          ...prevState[type],
          [name]: value,
        },
      }));
    else
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();

    // ARGS -> TOKEN, DATA, TRUESECTIONS, REFRESH_FORM
    submitButton("ABCD12345", source.key, formData, checkboxState, setRefresh);

    setFormData(setupStateFromProps());
    setCheckboxState(getCheckBox());
    handleClose();
  };

  //For Different types of Inputs in the Form
  const resolveFormField = (formField, type) => {
    switch (formField.type) {
      case "Date":
        return (
          <TextField
            required={formField.required}
            name={formField.name}
            style={{ width: "100%" }}
            label={formField.name}
            placeholder="YYYY-mm-ddTHH:MM"
            type="datetime-local"
            onChange={(event) => {
              handleFormChange(event, type, formField.type);
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        );

      case "Radio":
        return (
          <>
            <p />
            <RadioGroup
              name={formField.name}
              value={
                type
                  ? formData[[type]][formField.name]
                  : formData[formField.name]
              }
              onChange={(event) => {
                handleFormChange(event, type);
              }}
            >
              {formField["choice"].map((value, index) => {
                return (
                  <FormControlLabel
                    value={value}
                    key={index}
                    control={<Radio />}
                    label={value}
                  />
                );
              })}
            </RadioGroup>
          </>
        );

      case "SubTypes":
        return (
          <>
            {formField.types.map((eachType) => {
              return (
                <>
                  <Row className="align-items-center mx-2 my-2">
                    <Col sm="4" className="my-2">
                      <Typography>{eachType.name}</Typography>
                    </Col>
                    <Col sm="8">
                      {resolveFormField(eachType, formField.name)}
                    </Col>
                  </Row>
                </>
              );
            })}
          </>
        );

      case "Options":
        return (
          <>
            <InputLabel id={formField.name} className="mx-3" shrink>
              {formField.name}
            </InputLabel>
            <Select
              multiple
              labelId={formField.name}
              value={
                type
                  ? formData[[type]][formField.name]
                  : formData[formField.name]
              }
              name={formField.name}
              onChange={(event) => {
                handleFormChange(event, type);
              }}
              style={{ width: "100%" }}
              required={formField.required}
              input={<Input />}
              renderValue={(selected) => selected.join(", ")}
              MenuProps={MenuProps}
            >
              {formOptions[formField.name].map((value) => {
                let text;
                let option;

                if (value["symbol"]) {
                  option = value["symbol"];
                  text = `${value["company_name"]}  (${value["symbol"]})`;
                } else {
                  option = value["key"];
                  text = value["name"];
                }

                return (
                  <MenuItem key={option} value={option}>
                    <Checkbox
                      checked={
                        type
                          ? formData[[type]][formField.name].indexOf(option) >
                            -1
                          : formData[formField.name].indexOf(option) > -1
                      }
                    />
                    <ListItemText primary={text} />
                  </MenuItem>
                );
              })}
            </Select>
          </>
        );

      default:
        return (
          <TextField
            value={
              type ? formData[[type]][formField.name] : formData[formField.name]
            }
            name={formField.name}
            style={{ width: "100%" }}
            label={formField.name}
            onChange={(event) => {
              handleFormChange(event, type, formField.number ? "number" : null);
            }}
            required={formField.required}
            type={formField.number ? "number" : "text"}
          />
        );
    }
  };

  //START OF MAIN RETURN
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="Combined-form-dialog-title"
        fullWidth
      >
        <DialogTitle id="form-dialog-title">Create Job</DialogTitle>
        <DialogContent>
          {/* <DialogContentText>Some Title</DialogContentText> */}

          <form onSubmit={handleFormSubmit}>
            <FormControl component="fieldset" className={classes.formControl}>
              <FormGroup>
                {commonFields.map((formField, index) => {
                  return (
                    <Row className="align-items-center mx-2 my-1">
                      <Col sm="4" className="my-2">
                        <Typography>{formField.name}</Typography>
                      </Col>
                      <Col sm="8">{resolveFormField(formField)}</Col>
                    </Row>
                  );
                })}
                <p />

                {Object.keys(formFields).map((key) => {
                  if (key !== "main" && key !== "common")
                    return (
                      <>
                        <Divider variant="fullWidth" />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={checkboxState[key]}
                              onChange={handleChange}
                              name={key}
                            />
                          }
                          label={`Create ${key}`}
                        />

                        {checkboxState[key] && (
                          <>
                            {formFields[key].map((formField, index) => {
                              return (
                                <Row className="align-items-center" key={index}>
                                  <Col sm="4" className="my-2">
                                    <Typography>{formField.name}</Typography>
                                  </Col>
                                  <Col sm="8">
                                    {resolveFormField(formField, key)}
                                  </Col>
                                </Row>
                              );
                            })}
                            <p />
                          </>
                        )}
                      </>
                    );
                  return null;
                })}

                <Divider variant="fullWidth" />
              </FormGroup>
            </FormControl>

            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Cancel
              </Button>
              <Button type="submit" color="primary">
                Submit Job
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CombinedJob;
